import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO_REQUEST__image_asset_segment } from '@shared/dto/+image/_requests/DTO_REQUEST__image_asset_segment';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../generation/STATE__generation';

export const REMOTE__image_asset_segment = createAsyncThunkSafe<void, DTO_REQUEST__image_asset_segment>(
  ENUM__network_event_client_to_server.IMAGE_ASSET_SEGMENT,
  async (request): Promise<any> => {
    return await send_to_server(ENUM__network_event_client_to_server.IMAGE_ASSET_SEGMENT, request);
  },
);

export function INIT_REMOTE__image_asset_segment(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__image_asset_segment.pending, (state, action) => {})
    .addCase(REMOTE__image_asset_segment.rejected, (state, action) => {})
    .addCase(REMOTE__image_asset_segment.fulfilled, (state, action: PayloadAction) => {});
}
